import { useState } from "react";
import { useLang } from "@/contexts/LanguageContext";
import { t } from "@/translations";
import { guestSpeakers } from "@/mocks/speakers";

const VISIBLE = 3;

export default function GuestSpeakers() {
  const { lang } = useLang();
  const tr = t[lang].guestSpeakers;
  const isEn = lang === "en";

  const [current, setCurrent] = useState(0);
  const total = guestSpeakers.length;
  const maxStart = total - VISIBLE;

  const prev = () => setCurrent((c) => Math.max(0, c - 1));
  const next = () => setCurrent((c) => Math.min(maxStart, c + 1));

  const visible = guestSpeakers.slice(current, current + VISIBLE);

  return (
    <section className="w-full py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-10">
          {tr.heading}
        </h2>

        <div className="relative">
          {/* Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {visible.map((speaker) => {
              const country = isEn ? speaker.countryEn : speaker.country;
              const title = isEn ? speaker.titleEn : speaker.title;
              const description = isEn ? speaker.descriptionEn : speaker.description;

              return (
                <div
                  key={speaker.id}
                  className="bg-[#fafafa] rounded-lg overflow-hidden border border-gray-100 flex flex-col"
                >
                  <div className="w-full h-52 overflow-hidden">
                    <img
                      src={speaker.image}
                      alt={speaker.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-5 flex flex-col gap-2 flex-1">
                    <div>
                      <p className="font-semibold text-gray-900 text-base">{speaker.name}</p>
                      <p className="text-xs text-gray-400">{country}</p>
                    </div>
                    <p className="text-sm text-gray-700 leading-relaxed">{title}</p>
                    {description && (
                      <p className="text-xs text-gray-500 mt-auto pt-2 border-t border-gray-100">
                        {description}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              onClick={prev}
              disabled={current === 0}
              className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-300 text-gray-600 hover:border-[#4caf50] hover:text-[#4caf50] disabled:opacity-30 disabled:cursor-not-allowed transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-lg" />
            </button>

            {/* Dots */}
            <div className="flex gap-1.5">
              {Array.from({ length: maxStart + 1 }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`w-2 h-2 rounded-full transition-colors cursor-pointer ${
                    i === current ? "bg-[#4caf50]" : "bg-gray-300"
                  }`}
                />
              ))}
            </div>

            <button
              onClick={next}
              disabled={current >= maxStart}
              className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-300 text-gray-600 hover:border-[#4caf50] hover:text-[#4caf50] disabled:opacity-30 disabled:cursor-not-allowed transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-lg" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
